import React, { useEffect, useState } from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  Col,
  Container,
  FormFeedback,
  FormGroup,
  Input,
  Label,
  Row,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { useFormik } from "formik";
import TimelineService from "../../services/KangarooServices/TimelineService";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import toast from "react-hot-toast";

const AddTimeline = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [initialData, setInitialData] = useState({});

  const fetchDetails = async () => {
    try {
      const result = await TimelineService.getDetails(id);
      setInitialData(result);
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    if (id) {
      fetchDetails();
    }
  }, [id]);
  console.log("hello",initialData)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      title: initialData.title || "",
      description: initialData.description || "",
      year: initialData.year || "",
    },
    validationSchema: Yup.object({
      year: Yup.number().required("Year is required"),
      title: Yup.string()
        .required("Title is required")
        .min(3, "Title must be at least 3 characters")
        .max(100, "Title must be at most 100 characters"),
      description: Yup.string()
        .required("Description is required")
        .min(5, "Description must be at least 5 characters"),
    }),
    onSubmit: async (values) => {
      //   await formik.validateForm();

      //   if (Object.keys(formik.errors).length > 0) {
      //     formik.setTouched(
      //       Object.keys(formik.initialValues).reduce((acc, key) => {
      //         acc[key] = true;
      //         return acc;
      //       }, {}),
      //       false
      //     );
      //     return;
      //   }

      try {
        const payload = {
          year: Number(values.year),
          title: values.title,
          description: values.description,
        };

        if (id) {
          await TimelineService.update(id, payload);
          toast.success("Timeline updated successfully");
        } else {
          await TimelineService.create(payload);
          toast.success("Timeline create successfully");
        }
        navigate("/timeline");
      } catch (error) {
        console.error(error);
        toast.error("An error occured. Please try againa");
      }
    },
  });

  const breadcrumbItems = [{ title: "Back to List", link: "/timeline" }];
  return (
    <Container fluid>
      <div className="page-content">
        <BreadCrumb
          title="Add Timeline"
          pageTitle="Timeline"
          breadcrumbItems={breadcrumbItems}
        />{" "}
        <form onSubmit={formik.handleSubmit}>
          <div className="d-flex justify-content-end gap-2 mb-2">
            <Button type="submit" color="success">
              {id ? "Update" : "Create"}
            </Button>
            <Button
              type="button"
              color="danger"
              onClick={() => navigate("/timeline")}
            >
              Cancel
            </Button>
          </div>

          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  {/* Year */}
                  <FormGroup>
                    <Label>Year</Label>
                    <Input
                      type="number"
                      name="year"
                      placeholder="e.g. 2023"
                      value={formik.values.year}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.year && !!formik.errors.year}
                    />
                    {formik.touched.year && formik.errors.year && (
                      <FormFeedback>{formik.errors.year}</FormFeedback>
                    )}
                  </FormGroup>

                  {/* Title */}
                  <FormGroup>
                    <Label>Title</Label>
                    <Input
                      name="title"
                      placeholder="e.g. Company Founded"
                      value={formik.values.title}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      invalid={formik.touched.title && !!formik.errors.title}
                    />
                    {formik.touched.title && formik.errors.title && (
                      <FormFeedback>{formik.errors.title}</FormFeedback>
                    )}
                  </FormGroup>

                  {/* Description */}
                  <FormGroup>
                    <Label>Description</Label>

                    <CKEditor
                      editor={ClassicEditor}
                      data={formik.values.description}
                      onChange={(event, editor) => {
                        const data = editor.getData();
                        formik.setFieldValue("description", data);
                      }}
                      onBlur={() => formik.setFieldTouched("description", true)}
                    />

                    {formik.touched.description &&
                      formik.errors.description && (
                        <div className="text-danger mt-1">
                          {formik.errors.description}
                        </div>
                      )}
                  </FormGroup>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </form>
      </div>
    </Container>
  );
};

export default AddTimeline;
